
import { useOnScrollTransition } from "@/hooks";
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "Heading2",
  props: {
    icon: String,
  },
  setup() {
    const heading = ref([]);

    useOnScrollTransition(heading, "animate-scroll-fade");

    return { heading };
  },
});
